document.addEventListener('mouseenter', function(e) {
  if (!e.target || typeof e.target.closest !== 'function') return;
  const swatch = e.target.closest('.card-color-swatch');
  if (!swatch) return;
  const card = swatch.closest('.card-wrapper');
  if (!card) return;
  const img = card.querySelector('img.motion-reduce');
  if (!img) return;
  const newSrc = swatch.dataset.variantImage;
  if (!newSrc) return;
  if (!img.dataset.originalSrc) img.dataset.originalSrc = img.src;
  img.removeAttribute('srcset');
  img.src = newSrc;
}, true);

document.addEventListener('mouseleave', function(e) {
  if (!e.target || typeof e.target.closest !== 'function') return;
  const swatch = e.target.closest('.card-color-swatch');
  if (!swatch) return;
  const card = swatch.closest('.card-wrapper');
  if (!card) return;
  const img = card.querySelector('img.motion-reduce');
  if (!img) return;
  if (img.dataset.originalSrc) {
    img.removeAttribute('srcset');
    img.src = img.dataset.originalSrc;
  }
}, true);

document.addEventListener('click', function(e) {
  if (!e.target || typeof e.target.closest !== 'function') return;
  const swatch = e.target.closest('.card-color-swatch');
  if (!swatch) return;
  e.preventDefault();
  e.stopPropagation();
  const variantUrl = swatch.dataset.variantUrl;
  if (variantUrl) window.location.href = variantUrl;
}, true);
